// extracted by mini-css-extract-plugin
export var addViewLink = "_r-1";
export var availabilityIcon = "_r-16";
export var availabilitySelectionIcon = "_r-15";
export var backButton = "_r-2";
export var backIcon = "_r-z";
export var conversationCount = "_r-3";
export var dragHandle = "_r-5";
export var dropdown = "_r-e";
export var dropdownIcon = "_r-7";
export var dropdownOption = "_r-6";
export var dropdownTriangle = "_r-d";
export var expand = "_r-f";
export var folder = "_r-i";
export var folderItem = "_r-c";
export var icon = "_r-8";
export var iconRow = "_r-9";
export var image = "_r-a";
export var logo = "_r-b";
export var navContainer = "_r-h";
export var navigationFooter = "_r-g";
export var pageShell = "_r-0";
export var placeholderAvailable = "_r-11";
export var placeholderBox = "_r-14";
export var placeholderBusy = "_r-13";
export var placeholderUnavailable = "_r-12";
export var profile = "_r-k";
export var profileContainer = "_r-m";
export var profileDropdown = "_r-n";
export var profileImage = "_r-l";
export var profileMain = "_r-o";
export var profileSubtitle = "_r-q";
export var profileTitle = "_r-p";
export var reorderIcon = "_r-r";
export var sentLine = "_r-u";
export var settingsHeader = "_r-s";
export var sidenavTextColor = "_r-y";
export var spamLine = "_r-t";
export var subitemWithTag = "_r-4";
export var supportItems = "_r-j";
export var teamText = "_r-10";
export var viewLine = "_r-x";
export var viewLineButton = "_r-w";
export var viewLineButtons = "_r-v";